/* mediaPlayerBase.tsx generated by @compiled/babel-plugin v0.38.1 */
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./mediaPlayerBase.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// Keep media player components used in media-viewer to use static colors from the new color palette to
// support the hybrid theming in media viewer https://product-fabric.atlassian.net/browse/DSP-6067
import React from 'react';
import { Component } from 'react';
import PlayIcon from '@atlaskit/icon/core/migration/video-play--vid-play';
import PauseIcon from '@atlaskit/icon/core/migration/video-pause--vid-pause';
import FullScreenIconOn from '@atlaskit/icon/core/migration/fullscreen-enter--vid-full-screen-on';
import FullScreenIconOff from '@atlaskit/icon/core/migration/shrink-diagonal--vid-full-screen-off';
import SoundIcon from '@atlaskit/icon/core/migration/volume-high--hipchat-outgoing-sound';
import VideoHdIcon from '@atlaskit/icon-lab/core/video-hd';
import VideoHdFilledIcon from '@atlaskit/icon-lab/core/video-hd-filled';
import DownloadIcon from '@atlaskit/icon/core/migration/download';
import { injectIntl } from 'react-intl-next';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import MediaButton from '../../MediaButton';
import Spinner from '@atlaskit/spinner';
import { WidthObserver } from '@atlaskit/width-detector';
import MediaPlayer from '../react-video-renderer';
import { TimeRange } from '../timeRange';
import VolumeRange from '../volumeRange';
import { CurrentTime, VolumeWrapper, LeftControls, RightControls, VolumeToggleWrapper, MutedIndicator, VolumeTimeRangeWrapper } from '../styled';
import { ControlsWrapper } from '../styled-compiled';
import { fireAnalyticsEvent, createCustomMediaPlayerScreenEvent, createMediaButtonClickedEvent, createMediaShortcutPressedEvent, createPlayPauseBlanketClickedEvent, createTimeRangeNavigatedEvent, createPlaybackSpeedChangedEvent, createCaptionUploadSucceededEventPayload, createCaptionDeleteSucceededEventPayload, createCaptionUploadFailedEventPayload, createCaptionDeleteFailedEventPayload, createCaptionDisplaySucceededEventPayload, createCaptionDisplayFailedEventPayload, createFirstPlayedTrackEvent, createPlayedTrackEvent } from '../analytics';
import { formatDuration } from '../../formatDuration';
import { Shortcut, keyCodes } from '../../shortcut';
import { toggleFullscreen, getFullscreenElement } from '../fullscreen';
import { messages } from '../../messages';
import simultaneousPlayManager from '../simultaneousPlayManager';
import { TimeSaver } from '../timeSaver';
import PlaybackSpeedControls from '../playbackSpeedControls';
import { CaptionsSelectControls } from './captionsSelectControls';
import { CaptionsAdminControls } from './captionsAdminControls';
import { PlayPauseBlanket } from '../playPauseBlanket';
import Tooltip from '@atlaskit/tooltip';
import { SkipTenBackwardIcon, SkipTenForwardIcon } from '@atlaskit/legacy-custom-icons';
import { fg } from '@atlaskit/platform-feature-flags';
import VideoSkipForwardTenIcon from '@atlaskit/icon/core/video-skip-forward-ten';
import VideoSkipBackwardTenIcon from '@atlaskit/icon/core/video-skip-backward-ten';
import { CaptionsUploaderBrowser } from './captions/artifactUploader';
import CaptionDeleteConfirmationModal from './captions/captionDeleteConfirmationModal';
var MINIMUM_DURATION_BEFORE_SAVING_TIME = 60;
var VIEWED_TRACKING_SECS = 2;
export var breakpoints = {
  LARGE_VIDEO_MAX_WIDTH: 570,
  MEDIUM_VIDEO_MAX_WIDTH: 430,
  SMALL_VIDEO_MAX_WIDTH: 260
};
var breakpointControls = {
  playPauseButton: function playPauseButton() {
    return true;
  },
  volume: function volume() {
    return true;
  },
  fullScreenButton: function fullScreenButton() {
    return true;
  },
  currentTime: function currentTime(playerWidth) {
    return playerWidth > breakpoints.SMALL_VIDEO_MAX_WIDTH;
  },
  captionsControls: function captionsControls(playerWidth) {
    return playerWidth > breakpoints.MEDIUM_VIDEO_MAX_WIDTH;
  },
  downloadButton: function downloadButton(playerWidth) {
    return playerWidth > breakpoints.MEDIUM_VIDEO_MAX_WIDTH;
  },
  volumeSlider: function volumeSlider(playerWidth) {
    return playerWidth > breakpoints.MEDIUM_VIDEO_MAX_WIDTH;
  },
  skipButtons: function skipButtons(playerWidth) {
    return playerWidth > breakpoints.LARGE_VIDEO_MAX_WIDTH;
  },
  speedControls: function speedControls(playerWidth) {
    return playerWidth > breakpoints.LARGE_VIDEO_MAX_WIDTH;
  },
  hdButton: function hdButton(playerWidth) {
    return playerWidth > breakpoints.LARGE_VIDEO_MAX_WIDTH;
  },
  captionsAdminControls: function captionsAdminControls(playerWidth) {
    return playerWidth > breakpoints.LARGE_VIDEO_MAX_WIDTH;
  }
};
var getPlayerSize = function getPlayerSize(playerWidth) {
  if (playerWidth > breakpoints.LARGE_VIDEO_MAX_WIDTH) {
    return 'xlarge';
  } else if (playerWidth > breakpoints.MEDIUM_VIDEO_MAX_WIDTH) {
    return 'large';
  } else if (playerWidth > breakpoints.SMALL_VIDEO_MAX_WIDTH) {
    return 'medium';
  } else {
    return 'small';
  }
};

/* Styles */

var timebarWrapperStyles = {
  root: "_kqswstnw _1bsb1osq _94n5u2gc"
};
var customVideoWrapperStyles = {
  root: "_1bsb1osq _4t3i1osq _uiztglyw"
};
var videoWrapperStyles = {
  root: "_1bsb1osq _4t3i1osq"
};
var timeWrapperStyles = {
  root: "_195gv47k _19pkze3t _otyr1jfw"
};
var spinnerWrapperStyles = {
  root: "_kqswstnw _154ize3t _1ltvze3t _1bsb1osq _4t3i1osq"
};
var _MediaPlayerBase = /*#__PURE__*/function (_Component) {
  function _MediaPlayerBase() {
    var _this;
    _classCallCheck(this, _MediaPlayerBase);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _MediaPlayerBase, [].concat(args));
    _defineProperty(_this, "videoWrapperRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "videoState", {
      isLoading: true,
      buffered: 0,
      currentTime: 0,
      volume: 1,
      status: 'paused',
      duration: 0,
      isMuted: false,
      currentActiveCues: function currentActiveCues() {
        return undefined;
      }
    });
    _defineProperty(_this, "wasPlayedOnce", false);
    _defineProperty(_this, "lastCurrentTime", 0);
    _defineProperty(_this, "timeSaver", new TimeSaver(_this.props.lastWatchTimeConfig));
    _defineProperty(_this, "state", {
      isFullScreenEnabled: false,
      playerWidth: 100,
      // initial value for playerSize: 'small', i.e. width < 260px
      playbackSpeed: 1,
      isArtifactUploaderOpen: false,
      artifactToDelete: undefined
    });
    _defineProperty(_this, "fireFirstPlayedTrackEvent", function () {
      var _this$props = _this.props,
        type = _this$props.type,
        identifier = _this$props.identifier,
        isHDActive = _this$props.isHDActive,
        isHDAvailable = _this$props.isHDAvailable,
        isAutoPlay = _this$props.isAutoPlay,
        createAnalyticsEvent = _this$props.createAnalyticsEvent;
      var _this$state = _this.state,
        isFullScreenEnabled = _this$state.isFullScreenEnabled,
        playbackSpeed = _this$state.playbackSpeed;
      var _this2 = _this,
        playerSize = _this2.playerSize;
      fireAnalyticsEvent(createFirstPlayedTrackEvent(type, {
        isAutoPlay: isAutoPlay,
        isHDAvailable: isHDAvailable,
        isHDActive: isHDActive,
        isFullScreenEnabled: isFullScreenEnabled,
        playerSize: playerSize,
        playbackSpeed: playbackSpeed
      }, identifier.id), createAnalyticsEvent);
    });
    _defineProperty(_this, "onFullScreenChange", function (e) {
      if (e.target !== _this.videoWrapperRef.current) {
        return;
      }
      var currentFullScreenMode = _this.state.isFullScreenEnabled;
      var isFullScreenEnabled = !!getFullscreenElement();
      if (currentFullScreenMode !== isFullScreenEnabled) {
        var _this$props$onFullscr, _this$props2;
        (_this$props$onFullscr = (_this$props2 = _this.props).onFullscreenChange) === null || _this$props$onFullscr === void 0 || _this$props$onFullscr.call(_this$props2, isFullScreenEnabled);
        _this.setState({
          isFullScreenEnabled: isFullScreenEnabled
        });
      }
    });
    _defineProperty(_this, "onTimeChanged", function () {
      var _this$props$onTimeCha, _this$props3;
      _this.createAndFireUIEvent('timeRangeNavigate', 'time');
      (_this$props$onTimeCha = (_this$props3 = _this.props).onTimeChanged) === null || _this$props$onTimeCha === void 0 || _this$props$onTimeCha.call(_this$props3);
    });
    _defineProperty(_this, "onVolumeChanged", function () {
      _this.createAndFireUIEvent('volumeRangeNavigate', 'volume');
    });
    _defineProperty(_this, "getDefaultTime", function () {
      return _this.timeSaver.defaultTime;
    });
    _defineProperty(_this, "onCurrentTimeChange", function (currentTime, duration) {
      // We rely on the saved time when switching to the new source URL
      // so we need to save it irrespective of elapsed time or video length
      if (fg('platform_media_resume_video_on_token_expiry')) {
        _this.timeSaver.defaultTime = currentTime;
      } else if (duration - currentTime > MINIMUM_DURATION_BEFORE_SAVING_TIME) {
        _this.timeSaver.defaultTime = currentTime;
      } else {
        _this.timeSaver.defaultTime = 0;
      }
    });
    _defineProperty(_this, "shouldRenderCurrentTime", function () {
      return breakpointControls.currentTime(_this.state.playerWidth);
    });
    _defineProperty(_this, "renderCurrentTime", function () {
      return /*#__PURE__*/React.createElement(CurrentTime, {
        draggable: false,
        "data-testid": "current-time"
      }, formatDuration(_this.videoState.currentTime), " / ", formatDuration(_this.videoState.duration));
    });
    _defineProperty(_this, "shouldRenderHdButton", function () {
      var _this$props4 = _this.props,
        type = _this$props4.type,
        isHDAvailable = _this$props4.isHDAvailable;
      return !fg('platform_media_disable_video_640p_artifact_usage') && breakpointControls.hdButton(_this.state.playerWidth) && type !== 'audio' && !!isHDAvailable;
    });
    _defineProperty(_this, "renderHDButton", function () {
      var _this$props5 = _this.props,
        isHDActive = _this$props5.isHDActive,
        onHDToggleClick = _this$props5.onHDToggleClick;
      return /*#__PURE__*/React.createElement(MediaButton, {
        testId: "custom-media-player-hd-button",
        onClick: !!onHDToggleClick ? _this.getMediaButtonClickHandler(onHDToggleClick, 'HDButton') : undefined,
        iconBefore: isHDActive ? /*#__PURE__*/React.createElement(VideoHdFilledIcon, {
          label: "hd active"
        }) : /*#__PURE__*/React.createElement(VideoHdIcon, {
          label: "hd inactive"
        }),
        "aria-pressed": isHDActive
      });
    });
    _defineProperty(_this, "onPlaybackSpeedChange", function (playbackSpeed) {
      if (!_this.actions) {
        return;
      }
      _this.actions.setPlaybackSpeed(playbackSpeed);
      _this.setState({
        playbackSpeed: playbackSpeed
      });
      _this.createAndFireUIEvent('playbackSpeedChange');
    });
    _defineProperty(_this, "shouldRenderSpeedControls", function () {
      return breakpointControls.speedControls(_this.state.playerWidth);
    });
    _defineProperty(_this, "renderSpeedControls", function () {
      var playbackSpeed = _this.state.playbackSpeed;
      var originalDimensions = _this.props.originalDimensions;
      return /*#__PURE__*/React.createElement(PlaybackSpeedControls, {
        originalDimensions: originalDimensions,
        playbackSpeed: playbackSpeed,
        onPlaybackSpeedChange: _this.onPlaybackSpeedChange,
        onClick: function onClick() {
          return _this.createAndFireUIEvent('mediaButtonClick', 'playbackSpeedButton');
        }
      });
    });
    _defineProperty(_this, "shouldRenderVolume", function () {
      return breakpointControls.volume(_this.state.playerWidth);
    });
    _defineProperty(_this, "shouldRenderVolumeSLider", function () {
      return breakpointControls.volumeSlider(_this.state.playerWidth);
    });
    _defineProperty(_this, "renderVolume", function () {
      var _this$actions, _this$actions2;
      var showSlider = _this.shouldRenderVolumeSLider();
      return /*#__PURE__*/React.createElement(VolumeWrapper, {
        showSlider: showSlider
      }, /*#__PURE__*/React.createElement(VolumeToggleWrapper, {
        isMuted: _this.videoState.isMuted
      }, /*#__PURE__*/React.createElement(MutedIndicator, {
        isMuted: _this.videoState.isMuted
      }), /*#__PURE__*/React.createElement(MediaButton, {
        testId: "custom-media-player-volume-toggle-button",
        onClick: _this.getMediaButtonClickHandler(((_this$actions = _this.actions) === null || _this$actions === void 0 ? void 0 : _this$actions.toggleMute) || function () {
          return undefined;
        }, 'muteButton'),
        iconBefore: /*#__PURE__*/React.createElement(SoundIcon, {
          color: "currentColor",
          label: _this.props.intl.formatMessage(messages.volumeMuteButtonAria)
        }),
        "aria-pressed": _this.videoState.isMuted
      })), showSlider && /*#__PURE__*/React.createElement(VolumeTimeRangeWrapper, {
        "data-testid": "volume-time-range-wrapper"
      }, /*#__PURE__*/React.createElement(VolumeRange, {
        onChange: ((_this$actions2 = _this.actions) === null || _this$actions2 === void 0 ? void 0 : _this$actions2.setVolume) || function () {
          return undefined;
        },
        currentVolume: _this.videoState.volume,
        isAlwaysActive: true,
        onChanged: _this.onVolumeChanged,
        ariaLabel: _this.props.intl.formatMessage(messages.volumeLevelControlAria)
      })));
    });
    _defineProperty(_this, "toggleFullscreen", function () {
      return _this.videoWrapperRef.current && toggleFullscreen(_this.videoWrapperRef.current);
    });
    _defineProperty(_this, "onFullScreenButtonClick", function () {
      _this.toggleFullscreen();
      _this.createAndFireUIEvent('mediaButtonClick', 'fullScreenButton');
    });
    _defineProperty(_this, "onResize", function (width) {
      _this.setState({
        playerWidth: width
      });
    });
    _defineProperty(_this, "shouldRenderFullScreenButton", function () {
      return breakpointControls.fullScreenButton(_this.state.playerWidth);
    });
    _defineProperty(_this, "renderFullScreenButton", function () {
      var _this$props6 = _this.props,
        formatMessage = _this$props6.intl.formatMessage,
        type = _this$props6.type;
      if (type === 'audio') {
        return;
      }
      var isFullScreenEnabled = _this.state.isFullScreenEnabled;
      var icon = isFullScreenEnabled ? /*#__PURE__*/React.createElement(FullScreenIconOff, {
        color: "currentColor",
        label: formatMessage(messages.disable_fullscreen)
      }) : /*#__PURE__*/React.createElement(FullScreenIconOn, {
        color: "currentColor",
        label: formatMessage(messages.enable_fullscreen)
      });
      return /*#__PURE__*/React.createElement(MediaButton, {
        testId: "custom-media-player-fullscreen-button",
        onClick: _this.onFullScreenButtonClick,
        iconBefore: icon
      });
    });
    _defineProperty(_this, "shouldRenderDownloadButton", function () {
      return breakpointControls.downloadButton(_this.state.playerWidth);
    });
    _defineProperty(_this, "renderDownloadButton", function () {
      return _this.props.onDownloadClick && /*#__PURE__*/React.createElement(MediaButton, {
        testId: "custom-media-player-download-button",
        onClick: _this.getMediaButtonClickHandler(_this.props.onDownloadClick, 'downloadButton'),
        iconBefore: /*#__PURE__*/React.createElement(DownloadIcon, {
          color: "currentColor",
          label: "download"
        })
      });
    });
    _defineProperty(_this, "renderShortcuts", function (_ref) {
      var togglePlayPauseAction = _ref.togglePlayPauseAction,
        toggleMute = _ref.toggleMute,
        skipBackward = _ref.skipBackward,
        skipForward = _ref.skipForward;
      var isShortcutEnabled = _this.props.isShortcutEnabled;
      var isFullScreenEnabled = _this.state.isFullScreenEnabled;
      var shortcuts = (isShortcutEnabled || isFullScreenEnabled) && [/*#__PURE__*/React.createElement(Shortcut, {
        key: "space-shortcut",
        code: keyCodes.space,
        handler: _this.getKeyboardShortcutHandler(togglePlayPauseAction, 'space')
      }), /*#__PURE__*/React.createElement(Shortcut, {
        key: "m-shortcut",
        code: keyCodes.m,
        handler: _this.getKeyboardShortcutHandler(toggleMute, 'mute')
      })];
      if (shortcuts && isFullScreenEnabled) {
        // Fullscreen shortcuts only. We don't want to override left/right keys in media-viewer settings
        shortcuts.push( /*#__PURE__*/React.createElement(Shortcut, {
          key: "skip-backward-shortcut",
          code: keyCodes.leftArrow,
          handler: _this.getKeyboardShortcutHandler(skipBackward, 'leftArrow')
        }));
        shortcuts.push( /*#__PURE__*/React.createElement(Shortcut, {
          key: "skip-forward-shortcut",
          code: keyCodes.rightArrow,
          handler: _this.getKeyboardShortcutHandler(skipForward, 'rightArrow')
        }));
      }
      return shortcuts;
    });
    _defineProperty(_this, "shouldRenderPlayPauseButton", function () {
      return breakpointControls.playPauseButton(_this.state.playerWidth);
    });
    _defineProperty(_this, "renderPlayPauseButton", function () {
      var formatMessage = _this.props.intl.formatMessage;
      var toggleButtonIcon = _this.isPlaying ? /*#__PURE__*/React.createElement(PauseIcon, {
        spacing: "spacious",
        color: "currentColor",
        label: formatMessage(messages.pause)
      }) : /*#__PURE__*/React.createElement(PlayIcon, {
        spacing: "spacious",
        color: "currentColor",
        label: formatMessage(messages.play)
      });
      return /*#__PURE__*/React.createElement(Tooltip, {
        content: formatMessage(_this.isPlaying ? messages.pause : messages.play),
        position: "top"
      }, /*#__PURE__*/React.createElement(MediaButton, {
        testId: "custom-media-player-play-toggle-button",
        "data-test-is-playing": _this.isPlaying,
        iconBefore: toggleButtonIcon,
        onClick: _this.isPlaying ? _this.pausePlayByButtonClick : _this.startPlayByButtonClick
      }));
    });
    _defineProperty(_this, "defaultSkipAmount", 10);
    _defineProperty(_this, "skipBackward", function () {
      var _this$actions3, _this$props$onTimeCha2, _this$props7;
      var skipAmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.defaultSkipAmount;
      var newTime = _this.videoState.currentTime - skipAmount;
      (_this$actions3 = _this.actions) === null || _this$actions3 === void 0 || _this$actions3.navigate(Math.max(newTime, 0));
      (_this$props$onTimeCha2 = (_this$props7 = _this.props).onTimeChanged) === null || _this$props$onTimeCha2 === void 0 || _this$props$onTimeCha2.call(_this$props7);
    });
    _defineProperty(_this, "skipForward", function () {
      var _this$actions4, _this$props$onTimeCha3, _this$props8;
      var skipAmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.defaultSkipAmount;
      var newTime = _this.videoState.currentTime + skipAmount;
      (_this$actions4 = _this.actions) === null || _this$actions4 === void 0 || _this$actions4.navigate(Math.min(newTime, _this.videoState.duration));
      (_this$props$onTimeCha3 = (_this$props8 = _this.props).onTimeChanged) === null || _this$props$onTimeCha3 === void 0 || _this$props$onTimeCha3.call(_this$props8);
    });
    _defineProperty(_this, "renderSkipBackwardButton", function () {
      var formatMessage = _this.props.intl.formatMessage;
      return /*#__PURE__*/React.createElement(Tooltip, {
        content: formatMessage(messages.skipBackward),
        position: "top"
      }, /*#__PURE__*/React.createElement(MediaButton, {
        testId: "custom-media-player-skip-backward-button",
        iconBefore: /*#__PURE__*/React.createElement(VideoSkipBackwardTenIcon, {
          spacing: "spacious",
          LEGACY_fallbackIcon: SkipTenBackwardIcon,
          label: formatMessage(messages.skipBackward)
        }),
        onClick: _this.getMediaButtonClickHandler(_this.skipBackward, 'skipBackwardButton')
      }));
    });
    _defineProperty(_this, "renderSkipForwardButton", function () {
      var formatMessage = _this.props.intl.formatMessage;
      return /*#__PURE__*/React.createElement(Tooltip, {
        content: formatMessage(messages.skipForward),
        position: "top"
      }, /*#__PURE__*/React.createElement(MediaButton, {
        testId: "custom-media-player-skip-forward-button",
        iconBefore: /*#__PURE__*/React.createElement(VideoSkipForwardTenIcon, {
          spacing: "spacious",
          LEGACY_fallbackIcon: SkipTenForwardIcon,
          label: formatMessage(messages.skipForward)
        }),
        onClick: _this.getMediaButtonClickHandler(_this.skipForward, 'skipForwardButton')
      }));
    });
    _defineProperty(_this, "shouldRenderSkipButtons", function () {
      return breakpointControls.skipButtons(_this.state.playerWidth);
    });
    _defineProperty(_this, "renderSkipButtons", function () {
      return /*#__PURE__*/React.createElement(Flex, {
        direction: "row"
      }, _this.renderSkipBackwardButton(), _this.renderSkipForwardButton());
    });
    _defineProperty(_this, "renderSpinner", function () {
      return /*#__PURE__*/React.createElement(Flex, {
        testId: "spinner",
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
        xcss: spinnerWrapperStyles.root
      }, /*#__PURE__*/React.createElement(Spinner, {
        appearance: "invert",
        size: "large"
      }));
    });
    _defineProperty(_this, "pause", function () {
      var _this$props$onPause, _this$props9;
      if (_this.actions) {
        _this.actions.pause();
      }
      (_this$props$onPause = (_this$props9 = _this.props).onPause) === null || _this$props$onPause === void 0 || _this$props$onPause.call(_this$props9);
    });
    _defineProperty(_this, "play", function () {
      var _this$props0 = _this.props,
        onFirstPlay = _this$props0.onFirstPlay,
        onPlay = _this$props0.onPlay;
      if (_this.actions) {
        _this.actions.play();
      }
      simultaneousPlayManager.pauseOthers(_this);
      if (!_this.wasPlayedOnce && onFirstPlay) {
        _this.fireFirstPlayedTrackEvent();
        _this.wasPlayedOnce = true;
        onFirstPlay();
      }
      onPlay === null || onPlay === void 0 || onPlay();
    });
    _defineProperty(_this, "getMediaButtonClickHandler", function (action, buttonType) {
      return function () {
        action();
        _this.createAndFireUIEvent('mediaButtonClick', buttonType);
      };
    });
    _defineProperty(_this, "getKeyboardShortcutHandler", function (action, shortcutType) {
      return function () {
        var showControls = _this.props.showControls;
        action();
        if (showControls) {
          showControls();
        }
        _this.createAndFireUIEvent('shortcutPress', shortcutType);
      };
    });
    _defineProperty(_this, "onViewed", function (videoState) {
      var _this$props1 = _this.props,
        createAnalyticsEvent = _this$props1.createAnalyticsEvent,
        identifier = _this$props1.identifier,
        isAutoPlay = _this$props1.isAutoPlay,
        isHDAvailable = _this$props1.isHDAvailable,
        isHDActive = _this$props1.isHDActive,
        type = _this$props1.type;
      var _this$state2 = _this.state,
        isFullScreenEnabled = _this$state2.isFullScreenEnabled,
        playbackSpeed = _this$state2.playbackSpeed;
      var _this3 = _this,
        playerSize = _this3.playerSize;
      var status = videoState.status,
        currentTime = videoState.currentTime;
      if (status === 'playing' && (currentTime < _this.lastCurrentTime || currentTime >= _this.lastCurrentTime + VIEWED_TRACKING_SECS)) {
        fireAnalyticsEvent(createPlayedTrackEvent(type, _objectSpread(_objectSpread({}, videoState), {}, {
          isAutoPlay: isAutoPlay,
          isHDAvailable: isHDAvailable,
          isHDActive: isHDActive,
          isFullScreenEnabled: isFullScreenEnabled,
          playerSize: playerSize,
          playbackSpeed: playbackSpeed
        }), identifier.id), createAnalyticsEvent);
        _this.lastCurrentTime = currentTime;
      }
    });
    _defineProperty(_this, "resetPendingPlayPauseToggleTimer", function () {
      if (_this.clickToTogglePlayTimeoutId !== undefined) {
        clearTimeout(_this.clickToTogglePlayTimeoutId);
      }
    });
    _defineProperty(_this, "doubleClickToFullscreen", function () {
      _this.resetPendingPlayPauseToggleTimer();
      _this.toggleFullscreen();
      // TODO Add an event similar to "playPauseBlanketClick" but for fullscreen trigger
    });
    _defineProperty(_this, "togglePlayByBlanketClick", function (action) {
      _this.resetPendingPlayPauseToggleTimer();
      _this.clickToTogglePlayTimeoutId = setTimeout(function () {
        action();
        _this.createAndFireUIEvent('playPauseBlanketClick');
      }, 200);
    });
    _defineProperty(_this, "startPlayByBlanketClick", function () {
      _this.togglePlayByBlanketClick(_this.play);
    });
    _defineProperty(_this, "pausePlayByBlanketClick", function () {
      _this.togglePlayByBlanketClick(_this.pause);
    });
    _defineProperty(_this, "startPlayByButtonClick", _this.getMediaButtonClickHandler(_this.play, 'playButton'));
    _defineProperty(_this, "pausePlayByButtonClick", _this.getMediaButtonClickHandler(_this.pause, 'pauseButton'));
    _defineProperty(_this, "onTextTracksSelected", function (selectedTracksIndex) {
      var _this$props$onTextTra, _this$props10;
      (_this$props$onTextTra = (_this$props10 = _this.props).onTextTracksSelected) === null || _this$props$onTextTra === void 0 || _this$props$onTextTra.call(_this$props10, selectedTracksIndex);
    });
    _defineProperty(_this, "onCaptionsEnabledChange", function (areCaptionsEnabled) {
      var _this$props$onCaption, _this$props11;
      (_this$props$onCaption = (_this$props11 = _this.props).onCaptionsEnabledChange) === null || _this$props$onCaption === void 0 || _this$props$onCaption.call(_this$props11, areCaptionsEnabled);
    });
    _defineProperty(_this, "onCaptionDelete", function (artifactName) {
      // Modal is not supported in fullscreen mode (as it uses portals which are not in the same DOM tree),
      // So we need to exit fullscreen first
      if (_this.state.isFullScreenEnabled) {
        _this.toggleFullscreen();
      }
      _this.setState({
        artifactToDelete: artifactName
      });
    });
    _defineProperty(_this, "shouldRenderCaptionsControls", function () {
      var _textTracks$captions;
      var textTracks = _this.props.textTracks;
      var playerWidth = _this.state.playerWidth;
      return breakpointControls.captionsControls(playerWidth) && !!textTracks && !!((_textTracks$captions = textTracks.captions) !== null && _textTracks$captions !== void 0 && (_textTracks$captions = _textTracks$captions.tracks) !== null && _textTracks$captions !== void 0 && _textTracks$captions.length);
    });
    _defineProperty(_this, "renderCaptionsControls", function () {
      var textTracks = _this.props.textTracks;
      var _ref2 = (textTracks === null || textTracks === void 0 ? void 0 : textTracks.captions) || {},
        _ref2$selectedTrackIn = _ref2.selectedTrackIndex,
        selectedTrackIndex = _ref2$selectedTrackIn === void 0 ? -1 : _ref2$selectedTrackIn;
      var areCaptionsEnabled = _this.props.areCaptionsEnabled;
      return textTracks && /*#__PURE__*/React.createElement(CaptionsSelectControls, {
        textTracks: textTracks,
        onSelected: _this.onTextTracksSelected,
        areCaptionsEnabled: !!areCaptionsEnabled,
        onCaptionsEnabledChange: _this.onCaptionsEnabledChange,
        selectedTracksIndex: selectedTrackIndex
      });
    });
    _defineProperty(_this, "shouldRenderCaptionsAdminControls", function () {
      var _this$props$mediaSett;
      var playerWidth = _this.state.playerWidth;
      return (!_this.props.fileState || _this.props.fileState.status !== 'uploading') && breakpointControls.captionsAdminControls(playerWidth) && !!((_this$props$mediaSett = _this.props.mediaSettings) !== null && _this$props$mediaSett !== void 0 && _this$props$mediaSett.canUpdateVideoCaptions);
    });
    _defineProperty(_this, "renderCaptionsAdminControls", function () {
      var _this$state3 = _this.state,
        isArtifactUploaderOpen = _this$state3.isArtifactUploaderOpen,
        artifactToDelete = _this$state3.artifactToDelete;
      var _this$props12 = _this.props,
        textTracks = _this$props12.textTracks,
        identifier = _this$props12.identifier;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CaptionsAdminControls, {
        textTracks: textTracks,
        onUpload: function onUpload() {
          return _this.setState({
            isArtifactUploaderOpen: true
          });
        },
        onDelete: _this.onCaptionDelete
      }), /*#__PURE__*/React.createElement(CaptionsUploaderBrowser, {
        identifier: identifier,
        isOpen: isArtifactUploaderOpen,
        onClose: function onClose() {
          return _this.setState({
            isArtifactUploaderOpen: false
          });
        },
        onEnd: function onEnd(_metadata, traceContext) {
          _this.fireCaptionUploadSucceededEvent(traceContext);
        },
        onError: function onError(err, traceContext) {
          _this.fireCaptionUploadFailedEvent(traceContext, err);
        }
      }), /*#__PURE__*/React.createElement(CaptionDeleteConfirmationModal, {
        identifier: identifier,
        artifactName: artifactToDelete,
        onClose: function onClose() {
          return _this.setState({
            artifactToDelete: ''
          });
        },
        onEnd: function onEnd(traceContext) {
          _this.fireCaptionDeleteSucceededEvent(traceContext);
          _this.setState({
            artifactToDelete: ''
          });
        },
        onError: function onError(err, artifactName, traceContext) {
          _this.fireCaptionDeleteFailedEvent(artifactName, traceContext, err);
          _this.setState({
            artifactToDelete: ''
          });
        }
      }));
    });
    _defineProperty(_this, "onTextTrackLoaded", function () {
      _this.fireCaptionDisplaySucceededEvent();
    });
    _defineProperty(_this, "onTextTrackError", function (artifactName, lang, label) {
      _this.fireCaptionDisplayFailedEvent(artifactName, new Error("label: ".concat(label, " - lang: ").concat(lang)));
    });
    return _this;
  }
  _inherits(_MediaPlayerBase, _Component);
  return _createClass(_MediaPlayerBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props13 = this.props,
        type = _this$props13.type,
        identifier = _this$props13.identifier,
        isAutoPlay = _this$props13.isAutoPlay,
        isHDAvailable = _this$props13.isHDAvailable,
        isHDActive = _this$props13.isHDActive,
        onFirstPlay = _this$props13.onFirstPlay,
        createAnalyticsEvent = _this$props13.createAnalyticsEvent;
      var _this$state4 = this.state,
        isFullScreenEnabled = _this$state4.isFullScreenEnabled,
        playbackSpeed = _this$state4.playbackSpeed;
      var playerSize = this.playerSize;
      fireAnalyticsEvent(createCustomMediaPlayerScreenEvent(type, {
        isAutoPlay: isAutoPlay,
        isHDAvailable: isHDAvailable,
        isHDActive: isHDActive,
        isFullScreenEnabled: isFullScreenEnabled,
        playerSize: playerSize,
        playbackSpeed: playbackSpeed
      }, identifier.id), createAnalyticsEvent);
      if (this.videoWrapperRef.current) {
        this.videoWrapperRef.current.addEventListener('fullscreenchange', this.onFullScreenChange);
        this.onResize(this.videoWrapperRef.current.getBoundingClientRect().width);
      }
      simultaneousPlayManager.subscribe(this);
      if (isAutoPlay) {
        var _this$props$onPlay, _this$props14;
        simultaneousPlayManager.pauseOthers(this);
        if (onFirstPlay) {
          this.fireFirstPlayedTrackEvent();
          this.wasPlayedOnce = true;
          onFirstPlay();
        }
        (_this$props$onPlay = (_this$props14 = this.props).onPlay) === null || _this$props$onPlay === void 0 || _this$props$onPlay.call(_this$props14);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.videoWrapperRef.current) {
        this.videoWrapperRef.current.removeEventListener('fullscreenchange', this.onFullScreenChange);
      }
      if (this.state.isFullScreenEnabled) {
        var _this$props$onFullscr2, _this$props15;
        (_this$props$onFullscr2 = (_this$props15 = this.props).onFullscreenChange) === null || _this$props$onFullscr2 === void 0 || _this$props$onFullscr2.call(_this$props15, false);
      }
      simultaneousPlayManager.unsubscribe(this);
    }
  }, {
    key: "playerSize",
    get: function get() {
      return getPlayerSize(this.state.playerWidth);
    }
  }, {
    key: "setActions",
    value: function setActions(actions) {
      // Actions are being sent constantly while the video is playing,
      // though play and pause functions are always the same objects
      if (!this.actions) {
        this.actions = actions;
      }
    }
  }, {
    key: "createAndFireUIEvent",
    value: function createAndFireUIEvent(eventType, actionSubjectId) {
      var _this$props16 = this.props,
        type = _this$props16.type,
        identifier = _this$props16.identifier,
        isHDActive = _this$props16.isHDActive,
        isHDAvailable = _this$props16.isHDAvailable,
        isAutoPlay = _this$props16.isAutoPlay,
        createAnalyticsEvent = _this$props16.createAnalyticsEvent;
      var _this$state5 = this.state,
        isFullScreenEnabled = _this$state5.isFullScreenEnabled,
        playbackSpeed = _this$state5.playbackSpeed;
      var playerSize = this.playerSize;
      var playbackState = _objectSpread(_objectSpread({}, this.videoState), {}, {
        isAutoPlay: isAutoPlay,
        isHDAvailable: isHDAvailable,
        isHDActive: isHDActive,
        isFullScreenEnabled: isFullScreenEnabled,
        playerSize: playerSize,
        playbackSpeed: playbackSpeed
      });
      var analyticsEvent;
      switch (eventType) {
        case 'mediaButtonClick':
          analyticsEvent = createMediaButtonClickedEvent(type, playbackState, actionSubjectId, identifier.id);
          break;
        case 'shortcutPress':
          analyticsEvent = createMediaShortcutPressedEvent(type, playbackState, actionSubjectId, identifier.id);
          break;
        case 'playPauseBlanketClick':
          analyticsEvent = createPlayPauseBlanketClickedEvent(type, playbackState, identifier.id);
          break;
        case 'timeRangeNavigate':
        case 'volumeRangeNavigate':
          analyticsEvent = createTimeRangeNavigatedEvent(type, playbackState, actionSubjectId, identifier.id);
          break;
        case 'playbackSpeedChange':
          analyticsEvent = createPlaybackSpeedChangedEvent(type, playbackState, identifier.id);
          break;
        default:
          analyticsEvent = {
            eventType: 'ui',
            action: 'default',
            actionSubject: 'customMediaPlayer',
            attributes: {
              type: type
            }
          };
      }
      fireAnalyticsEvent(analyticsEvent, createAnalyticsEvent);
    }
  }, {
    key: "baseAnalyticCaptionAttributes",
    value: function baseAnalyticCaptionAttributes() {
      var _textTracks$captions2;
      var textTracks = this.props.textTracks;
      var _ref3 = (textTracks === null || textTracks === void 0 ? void 0 : textTracks.captions) || {},
        _ref3$selectedTrackIn = _ref3.selectedTrackIndex,
        selectedTrackIndex = _ref3$selectedTrackIn === void 0 ? -1 : _ref3$selectedTrackIn;
      var captionTracks = textTracks === null || textTracks === void 0 || (_textTracks$captions2 = textTracks.captions) === null || _textTracks$captions2 === void 0 ? void 0 : _textTracks$captions2.tracks;
      var selectedTrack = captionTracks === null || captionTracks === void 0 ? void 0 : captionTracks[selectedTrackIndex];
      var captionAttributes = {
        selectedTrackIndex: selectedTrackIndex,
        availableCaptionTracks: (captionTracks === null || captionTracks === void 0 ? void 0 : captionTracks.length) || 0,
        selectedTrackLanguage: (selectedTrack === null || selectedTrack === void 0 ? void 0 : selectedTrack.lang) || null
      };
      return captionAttributes;
    }
  }, {
    key: "fireCaptionEvent",
    value: function fireCaptionEvent(payload) {
      fireAnalyticsEvent(payload, this.props.createAnalyticsEvent);
    }
  }, {
    key: "fireCaptionDisplaySucceededEvent",
    value: function fireCaptionDisplaySucceededEvent() {
      this.fireCaptionEvent(createCaptionDisplaySucceededEventPayload(this.props.type, this.baseAnalyticCaptionAttributes(), this.props.identifier.id));
    }
  }, {
    key: "fireCaptionDisplayFailedEvent",
    value: function fireCaptionDisplayFailedEvent(artifactName, error) {
      this.fireCaptionEvent(createCaptionDisplayFailedEventPayload(this.props.type, 'render-fail', _objectSpread(_objectSpread({}, this.baseAnalyticCaptionAttributes()), {}, {
        artifactName: artifactName
      }), this.props.identifier.id, error));
    }
  }, {
    key: "fireCaptionUploadSucceededEvent",
    value: function fireCaptionUploadSucceededEvent(traceContext) {
      this.fireCaptionEvent(createCaptionUploadSucceededEventPayload(this.props.type, this.baseAnalyticCaptionAttributes(), this.props.identifier.id, traceContext));
    }
  }, {
    key: "fireCaptionUploadFailedEvent",
    value: function fireCaptionUploadFailedEvent(traceContext, error) {
      this.fireCaptionEvent(createCaptionUploadFailedEventPayload(this.props.type, this.baseAnalyticCaptionAttributes(), this.props.identifier.id, error, traceContext));
    }
  }, {
    key: "fireCaptionDeleteSucceededEvent",
    value: function fireCaptionDeleteSucceededEvent(traceContext) {
      this.fireCaptionEvent(createCaptionDeleteSucceededEventPayload(this.props.type, this.baseAnalyticCaptionAttributes(), this.props.identifier.id, traceContext));
    }
  }, {
    key: "fireCaptionDeleteFailedEvent",
    value: function fireCaptionDeleteFailedEvent(artifactName, traceContext, error) {
      this.fireCaptionEvent(createCaptionDeleteFailedEventPayload(this.props.type, _objectSpread(_objectSpread({}, this.baseAnalyticCaptionAttributes()), {}, {
        artifactName: artifactName
      }), this.props.identifier.id, error, traceContext));
    }
  }, {
    key: "isPlaying",
    get: function get() {
      return this.videoState.status === 'playing';
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props17 = this.props,
        type = _this$props17.type,
        src = _this$props17.src,
        isAutoPlay = _this$props17.isAutoPlay,
        onCanPlay = _this$props17.onCanPlay,
        onError = _this$props17.onError,
        poster = _this$props17.poster,
        videoControlsWrapperRef = _this$props17.videoControlsWrapperRef,
        areControlsVisible = _this$props17.areControlsVisible,
        textTracks = _this$props17.textTracks;
      return /*#__PURE__*/React.createElement(Box, {
        xcss: customVideoWrapperStyles.root,
        ref: this.videoWrapperRef,
        testId: "custom-media-player"
      }, /*#__PURE__*/React.createElement(MediaPlayer, {
        sourceType: type,
        src: src,
        autoPlay: isAutoPlay,
        onCanPlay: onCanPlay,
        defaultTime: this.getDefaultTime,
        onTimeChange: this.onCurrentTimeChange,
        onError: onError,
        poster: poster,
        textTracks: textTracks,
        textTracksPosition: areControlsVisible ? -3.7 : undefined,
        onTextTrackLoaded: this.onTextTrackLoaded,
        onTextTrackError: this.onTextTrackError
      }, function (video, videoState, actions) {
        _this4.onViewed(videoState);
        _this4.setActions(actions);
        //Video State(either prop or variable) is ReadOnly
        _this4.videoState = videoState;
        var currentTime = videoState.currentTime,
          buffered = videoState.buffered,
          duration = videoState.duration,
          isLoading = videoState.isLoading;
        var shortcuts = _this4.renderShortcuts({
          togglePlayPauseAction: _this4.isPlaying ? _this4.pause : _this4.play,
          toggleMute: actions.toggleMute,
          skipBackward: _this4.skipBackward,
          skipForward: _this4.skipForward
        });
        return /*#__PURE__*/React.createElement(Flex, {
          direction: "column",
          xcss: videoWrapperStyles.root
        }, /*#__PURE__*/React.createElement(WidthObserver, {
          setWidth: _this4.onResize
        }), shortcuts, isLoading && _this4.renderSpinner(), /*#__PURE__*/React.createElement(PlayPauseBlanket, {
          onDoubleClick: _this4.doubleClickToFullscreen,
          onClick: _this4.isPlaying ? _this4.pausePlayByBlanketClick : _this4.startPlayByBlanketClick,
          "data-testid": "play-pause-blanket"
        }, video), /*#__PURE__*/React.createElement(ControlsWrapper, {
          ref: videoControlsWrapperRef,
          controlsHidden: _this4.wasPlayedOnce
        }, /*#__PURE__*/React.createElement(Box, {
          xcss: timeWrapperStyles.root
        }, /*#__PURE__*/React.createElement(TimeRange, {
          currentTime: currentTime,
          bufferedTime: buffered,
          duration: duration,
          onChange: actions.navigate,
          onChanged: _this4.onTimeChanged,
          disableThumbTooltip: true,
          skipBackward: _this4.skipBackward,
          skipForward: _this4.skipForward,
          isAlwaysActive: false
        })), /*#__PURE__*/React.createElement(Flex, {
          alignItems: "center",
          justifyContent: "space-between",
          xcss: timebarWrapperStyles.root
        }, /*#__PURE__*/React.createElement(LeftControls, null, _this4.shouldRenderPlayPauseButton() && _this4.renderPlayPauseButton(), _this4.shouldRenderSkipButtons() && _this4.renderSkipButtons(), _this4.shouldRenderVolume() && _this4.renderVolume()), /*#__PURE__*/React.createElement(RightControls, null, _this4.shouldRenderCurrentTime() && _this4.renderCurrentTime(), _this4.shouldRenderCaptionsControls() && _this4.renderCaptionsControls(), _this4.shouldRenderSpeedControls() && _this4.renderSpeedControls(), _this4.shouldRenderHdButton() && _this4.renderHDButton(), _this4.shouldRenderDownloadButton() && _this4.renderDownloadButton(), _this4.shouldRenderFullScreenButton() && _this4.renderFullScreenButton(), _this4.shouldRenderCaptionsAdminControls() && _this4.renderCaptionsAdminControls()))));
      }));
    }
  }]);
}(Component);
export var MediaPlayerBase = injectIntl(_MediaPlayerBase);